import React from "react";
import OrganizationContextModel from "./organizationContextModel";

const OrganizationContext = React.createContext<
  OrganizationContextModel | undefined
>(undefined);
OrganizationContext.displayName = "OrganizationContext";

export default OrganizationContext;
